import { useContext, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import { Link } from "react-router-dom";
import Pagination from "../../components/Pagination";

const BlockUsers = () => {
  const { t } = useContext(LocaleContext);
  const [isChecked, setIsChecked] = useState(true);

  const handleChecked = () => {
    setIsChecked(!isChecked);
  };
  return (
    <section className="block-users">
      <div className="default-heading">{t("blockUsers")}</div>
      <section className="section-dashboard-cards mb-3">
        <div className="row">
          <div className="col-12 col-md-3">
            <div className="d-card d-card-primary">
              <div className="d-card-header">{t("totalUsers")}</div>
              <div className="d-card-body">
                <div className="d-card-body-1">
                  <span>7,125.70</span>
                  <span>{t("newThisMonth")}: 3</span>
                </div>
                <div className="d-card-body-2">
                  <span>52.0%</span>
                  <i className="fas fa-arrow-circle-up"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="d-card d-card-dark">
              <div className="d-card-header">{t("onlineUsers")}</div>
              <div className="d-card-body">
                <div className="d-card-body-1">
                  <span>7,125.70</span>
                  <span>{t("newThisMonth")}: 3</span>
                </div>
                <div className="d-card-body-2">
                  <span>52.0%</span>
                  <i className="fas fa-arrow-circle-up"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="d-card d-card-primary">
              <div className="d-card-header">{t("client")}</div>
              <div className="d-card-body">
                <div className="d-card-body-1">
                  <span>7,125.70</span>
                  <span>{t("newThisMonth")}: 3</span>
                </div>
                <div className="d-card-body-2">
                  <span>52.0%</span>
                  <i className="fas fa-arrow-circle-up"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="d-card d-card-dark">
              <div className="d-card-header">{t("totalRevenue")}</div>
              <div className="d-card-body">
                <div className="d-card-body-1">
                  <span>7,125.70</span>
                  <span>{t("newThisMonth")}: 3</span>
                </div>
                <div className="d-card-body-2">
                  <span>52.0%</span>
                  <i className="fas fa-arrow-circle-up"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-grid">
        <div className="grid-card">
          <div className="gird-card-header">
            <strong>{t("blockUsers")}</strong>
            <p>{t("theseAreYourLatestBlockedUsers")}</p>
          </div>
          <div className="grid-card-body">
            <div className="table-header">
              <div className="table-header-icons">
                <div className="icon-box">
                  <i className="fas fa-file-pdf"></i>
                </div>
                <div className="icon-box">
                  <i className="fas fa-file-excel"></i>
                </div>
              </div>
              <div className="table-search">
                <div className="input-icon input-icon-width">
                  <input
                    type="text"
                    className="form-control input-search"
                    placeholder={t("search")}
                  />
                  <i className="fas fa-search"></i>
                </div>
                <div className="grid-btn">
                  <Link to="/block-user-form">
                    <button className="btn-default my-bg-secondary">
                      <i className="fas fa-plus"></i> {t("addNewBlock")}
                    </button>
                  </Link>
                </div>
              </div>
            </div>
            <div className="table-delete-option mt-3">
              <b>{t("allCustomers")}</b>
              <div className="dropdown">
                <i
                  className="fas fa-filter cursor-pointer"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                />
                <span></span>
                <i className="fas fa-trash-alt"></i>
                <ul className="dropdown-menu">
                  <li>
                    <a className="dropdown-item" href="#">
                      <input type="radio" /> {t("status")}
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      <input type="radio" /> {t("mobileNo")}
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      <input type="radio" /> {t("city")}
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      <input type="radio" /> {t("date")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="my-table">
              <table className="table">
                <thead>
                  <tr>
                    <th>
                      <input type="checkbox" />
                    </th>
                    <th>{t("code")}</th>
                    <th>{t("userName")}</th>
                    <th>{t("mobileNo")}</th>
                    <th>{t("email")}</th>
                    <th>{t("city")}</th>
                    <th>{t("status")}</th>
                    <th>{t("date")}</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: 10 }).map((_, index) => (
                    <tr key={index}>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td>1</td>
                      <td>خالد حلمي</td>
                      <td>+966548735488</td>
                      <td>rahad121216@gmail.com</td>
                      <td>الدمام</td>

                      <td>
                        مجظور
                      </td>
                      <td>15-01-2026</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="grid-footer">
            <Pagination t={t} />
          </div>
        </div>
      </section>
    </section>
  );
};

export default BlockUsers;
